import React from "react";
import { useTranslation } from "react-i18next";

// Anteprima telefono: cosa vede il cliente premendo Prenota (pulsante attivo oppure messaggio di blocco).
// block: risultato di clientBlock (o null); note: riga facoltativa sotto il pulsante attivo.
const GOLD = "#b8932f";

const PhonePreview = ({ name, block, note, compact }) => {
  const { t } = useTranslation("bookings");
  const width = compact ? 200 : 230;
  return (
    <div
      className="mx-auto"
      style={{
        width, minHeight: compact ? 300 : 400, border: "10px solid #1d1b17", borderRadius: 30, background: "#fff",
        position: "relative", padding: "28px 14px 18px", color: "#1d1b17", boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
      }}
    >
      <div style={{ position: "absolute", top: 8, left: "50%", transform: "translateX(-50%)", width: 60, height: 6, borderRadius: 3, background: "#1d1b17" }} />
      <div className="text-center">
        <div style={{ fontWeight: 700, fontSize: 15 }} className="mb-3 text-truncate">{name || t("settings.previewRestaurant")}</div>
        {block ? (
          <div className="text-left p-2 rounded" style={{ background: "#fbf6ea", border: `1px solid ${GOLD}` }}>
            <div style={{ fontWeight: 700, fontSize: 13 }}>
              {block.kind === "pause" && t("settings.previewPause")}
              {block.kind === "closed" && t("settings.previewClosed", { name: block.title })}
              {block.kind === "off" && t("settings.previewOff")}
            </div>
            <p className="mb-1" style={{ fontSize: 12, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {block.message || t({ pause: "settings.previewDefaultPause", closed: "settings.previewDefaultClosed", off: "settings.previewOffMsg" }[block.kind])}
            </p>
            {block.kind === "pause" && block.retry && (
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {block.retry.tomorrow ? t("settings.retryTomorrow") : t("settings.retryAfter", { time: block.retry.time })}
              </div>
            )}
          </div>
        ) : (
          <>
            <button type="button" tabIndex={-1} className="btn btn-sm mt-4 px-4" style={{ background: GOLD, color: "#14120f", fontWeight: 700, cursor: "default" }}>
              {t("settings.book")}
            </button>
            {note && <div className="small text-muted mt-3">{note}</div>}
          </>
        )}
      </div>
    </div>
  );
};

export default PhonePreview;
